import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-microsoft-itfacilityform',
  templateUrl: './microsoft-itfacilityform.component.html',
  styleUrls: ['./microsoft-itfacilityform.component.scss']
})
export class MicrosoftITfacilityformComponent implements OnInit {
public Microsoft360cheker_data:any={};  
  constructor(public appservice:AppService,public toastr:ToastrService) { }
onApprove(){
this.Microsoft360cheker_data.status='Approved';
this.Microsoft360cheker_data.approvedby=this.appservice.username;
   this.appservice.getTable("api/Transaction/Update_checkerMicrosoft360?empid="+this.Microsoft360cheker_data.MD_EmployeeId+"&status="+this.Microsoft360cheker_data.status+"&command="+this.Microsoft360cheker_data.command+"&username="+this.Microsoft360cheker_data.approvedby).subscribe((res:any)=>{
    this.toastr.success("Approved successfully!");
    this.appservice.get_Microsoft360_ITfacilitygrid();
   });
  //this.appservice.checkeritfacilityedit='';
  //this.router.navigate(['/home/checkerreview'])
  this.appservice.goback();
}
back(){
  this.appservice.goback();
}
onformload(){
  this.appservice.getTable("api/Transaction/Microsoft_checkerEditdata?id="+this.appservice.Microsoft360editid).subscribe((res:any)=>{
    if(res!=""){
      this.Microsoft360cheker_data=JSON.parse(res).record[0];
      console.log("the edit data of microsoft 360 itfacility form",this.Microsoft360cheker_data)
    }
  });
}
onDecline(){
  if(this.Microsoft360cheker_data.command=="" || this.Microsoft360cheker_data.command==undefined){
    this.toastr.warning("The Commands Should not be empty","warning");
  }else{
    this.Microsoft360cheker_data.status='Rejected';
    this.Microsoft360cheker_data.approvedby=this.appservice.username;
    this.appservice.getTable("api/Transaction/Update_checkerMicrosoft360?empid="+this.Microsoft360cheker_data.MD_EmployeeId+"&status="+this.Microsoft360cheker_data.status+"&command="+this.Microsoft360cheker_data.command+"&username="+this.Microsoft360cheker_data.approvedby).subscribe((res:any)=>{
    this.toastr.success("Reject successfully!");
    this.appservice.get_Microsoft360_ITfacilitygrid();
   });
  //this.appservice.checkeritfacilityedit='';
  //this.router.navigate(['/home/checkerreview'])
  this.appservice.goback();
  }
}
  ngOnInit(): void {
    this.onformload();
  }

}
